import { isEmpty } from 'core/packages/utils';
import { fetch, Method } from 'core/api/fetch';

const expDetailRoutes = {
    save: '/api/v1.1.0/experience/',
    update: '/api/v1.1.0/experience/',
    imageDetail: '/image',
    videoDetail: '/youtube',
    savePDF: (experienceId) => `/api/v1.1.1/experiencer/experience/${experienceId}/ExperienceTerms`,
};

export const ExperienceInfoMediaService = {
    imageSave: async (expId, newData) => {
        try {
            const formData = new FormData();
            formData.append('images', newData);
            await fetch(`${expDetailRoutes.save}${expId}${expDetailRoutes.imageDetail}`, {
                method: Method.POST,
                authenticated: true,
                data: formData,
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
        } catch (err) {
            throw new Error(err);
        }
    },
    mediaDelete: async (expId, mediaId) => {
        try {
            await fetch(`${expDetailRoutes.save}${expId}/media/${mediaId}`, {
                method: Method.DELETE,
                authenticated: true,
            });
        } catch (err) {
            throw new Error(err);
        }
    },
    imageUpdate: async (expId, newData) => {
        try {
            await fetch(`${expDetailRoutes.save}${expId}${expDetailRoutes.imageDetail}`, {
                method: Method.PATCH,
                authenticated: true,
                data: JSON.stringify(newData),
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
        } catch (err) {
            throw new Error(err);
        }
    },
    videoSave: async (expId, newData) => {
        try {
            await fetch(`${expDetailRoutes.save}${expId}${expDetailRoutes.videoDetail}`, {
                method: Method.POST,
                authenticated: true,
                data: JSON.stringify(newData),
                headers: {
                    'Content-Type': 'application/json',
                },
            });
        } catch (err) {
            throw new Error(err);
        }
    },
    videoUpdate: async (expId, newData) => {
        try {
            await fetch(`${expDetailRoutes.save}${expId}${expDetailRoutes.videoDetail}`, {
                method: Method.PATCH,
                authenticated: true,
                data: JSON.stringify(newData),
                headers: {
                    'Content-Type': 'application/json',
                },
            });
        } catch (err) {
            throw new Error(err);
        }
    },

    // PDF
    savePDF: async (expId, newData) => {
        try {
            const formData = new FormData();
            formData.append('pdfFile', newData?.file);
            if (newData?.documentName) {
                formData.append('name', newData.documentName);
            }
            await fetch(expDetailRoutes.savePDF(expId), {
                method: Method.POST,
                authenticated: true,
                data: formData,
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            return true;
        } catch (err) {
            console.error(err);
            return false;
        }
    },
};
